<template>
  <Page class="text-whitebase">
    <div class="flex">
      <div class="left-area mr-12">
        <div class="text-5xl font-semibold mb-16">{{ state.info.daoName }}</div>
        <FormInput
          :modelValue="state.info.daoIntro"
          ref="input2"
          :textarea="true"
          placeholder="Please Enter"
          :maxLength="280"
          rows="6"
          disabled
        />
        <div class="mt-8 flex flex-wrap relative">
          <div
            v-for="item in baseInfo"
            :key="item.label"
            class="
              flex
              flex-item__hover
              justify-center
              items-center
              relative
              font-bold
            "
            :class="{
              'flex-item_3': passType == 'bonding_curve',
              'flex-item_4': passType == 'fixed_price',
            }"
          >
            <div class="flex-item__value">
              {{ item.value }} <span v-if="item.type == 'percent'">%</span>
            </div>

            <div
              class="
                flex-item__label
                absolute
                top-0
                bottom-0
                left-0
                right-8
                text-xs text-left
                pt-1
                pl-2
              "
            >
              {{ item.label }}
            </div>
            <div class="absolute right-0">
              <img
                class="w-4 h-4 opacity-60 mx-2"
                src="@/assets/images/icon_warning.avif"
                alt=""
              />
            </div>
          </div>
        </div>
      </div>
      <div class="right-area">
        <div class="w-full profit-bg relative mb-8" style="padding-top: 45.8%">
          <div class="absolute bottom-1 left-1">
            <div class="text-xs">
              {{ state.info.network }}
            </div>
            <div class="font-bold">
              {{ state.info.accumProfit || 0 }} {{ state.info.payWith }}
            </div>
            <div class="text-sm">Accumulated Income</div>
          </div>
        </div>
        <div class="border-line p-8">
          <div class="flex justify-between text-sm">
            <div class="font-bold">Receiving Address</div>

            <Popper placement="top" hover>
              <div
                class="
                  text-babyblue
                  w-40
                  overflow-hidden overflow-ellipsis
                  whitespace-nowrap
                  cursor-pointer
                "
                @click="copyTx(state.info.receivingAddress)"
              >
                {{ state.info.receivingAddress }}
              </div>

              <template v-slot:content="">
                <div
                  class="
                    text-xs text-whitebase
                    backdrop-filter backdrop-blur
                    py-2
                    px-3
                  "
                >
                  {{ state.info.receivingAddress }}
                </div>
              </template>
            </Popper>
          </div>
          <div class="flex justify-between text-sm mt-2">
            <div class="font-bold">Remaining Profit</div>
            <div>
              {{ (+state.undrawProfit).toFixed(6) }} {{ state.info.payWith }}
            </div>
          </div>
          <div class="line my-8 w-full"></div>
          <Button error @click="doWithdraw" :disabled="state.undrawProfit == 0"
            >Withdraw</Button
          >
        </div>
      </div>
    </div>
    <div>
      <div class="flex justify-between mt-12">
        <LineTitle class="text-3xl mb-4">HISTORY</LineTitle>
        <div>
          <Menu as="div" class="relative inline-block text-left w-full">
            <div>
              <MenuButton
                class="
                  inline-flex
                  justify-center
                  w-full
                  shadow-sm
                  px-4
                  bg-gradient-3
                  text-sm
                  font-medium
                  text-black
                  focus:outline-none
                  h-10
                  items-center
                "
              >
                {{ state.type }}
                <ChevronDownIcon
                  aria-hidden="true"
                  class="-mr-1 ml-2 h-5 w-5"
                />
              </MenuButton>
            </div>

            <transition
              enter-active-class="transition ease-out duration-100"
              enter-from-class="transform opacity-0 scale-95"
              enter-to-class="transform opacity-100 scale-100"
              leave-active-class="transition ease-in duration-75"
              leave-from-class="transform opacity-100 scale-100"
              leave-to-class="transform opacity-0 scale-95"
            >
              <MenuItems
                class="
                  origin-top-right
                  absolute
                  right-0
                  mt-2
                  shadow-lg
                  bg-background
                  ring-1 ring-black ring-opacity-5
                  focus:outline-none
                  border border-primary
                "
              >
                <div class="py-1 border-primary">
                  <MenuItem
                    v-for="option in options"
                    :key="option.text"
                    v-slot="{ active }"
                  >
                    <div
                      :class="[
                        active ? 'bg-primary text-black' : 'text-black',
                        'block px-4 py-2 text-sm font-medium',
                      ]"
                      @click="state.type = option.text"
                    >
                      <span class="font-mono font-bold">{{ option.text }}</span>
                    </div>
                  </MenuItem>
                </div>
              </MenuItems>
            </transition>
          </Menu>
        </div>
      </div>
      <div class="with-table box-bg">
        <div class="grid with-table__head ite font-bold">
          <div
            class="flex items-center pl-4"
            v-for="label in [
              'Token',
              'Tx ID',
              'Quantity',
              'Type',
              'Create Date',
            ]"
            :key="label"
          >
            {{ label }}
          </div>
        </div>

        <div class="overflow-y-scroll" style="height: 18rem">
          <div
            class="grid with-table__body"
            v-for="(item, i) in state.history"
            :key="i"
          >
            <div class="flex items-center pl-4">{{ state.info.payWith }}</div>
            <div class="flex items-center pl-4">
              <a
                :href="jumpHash(item.transactionHash)"
                class="
                  w-40
                  text-babyblue
                  overflow-hidden overflow-ellipsis
                  whitespace-nowrap
                  hover:underline
                "
                target="_blank"
              >
                {{ item.transactionHash }}
              </a>
            </div>

            <div class="flex items-center pl-4">{{ item.quantity || 0 }}</div>
            <div
              class="flex items-center pl-4"
              :style="{ color: item.type == 'Income' ? '#02C817' : '#F9021F' }"
            >
              {{ item.type }}
            </div>
            <div class="flex items-center pl-4 italic text-strong-gray">
              {{ formatDate(item.createDate, 'YYYY-MM-DD HH:mm:ss') }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </Page>
</template>

<script setup>
import { computed, onMounted, reactive, watch } from 'vue';
import { useRoute } from 'vue-router';
import Button from '@/components/Button.vue';
import Page from '@/components/Page.vue';
import FormInput from '@/components/Framework/FormInput.vue';
import LineTitle from '@/components/LineTitle.vue';
import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/vue';
import { ChevronDownIcon } from '@heroicons/vue/solid';
import { getDaoIdByName, getProfitsHistory, getProfitsInfo } from '@/api/dao';
import {
  PassTypeLongText,
  BONDING_CURVE_OPTIONS_BY_NETWORK,
  chainExplore,
} from '@/constants';
import {
  cutZero,
  delayTime,
  formatDate,
  getFixedTokenAddress,
  handleWalletError,
} from '@/utils';
import {
  clearDecimals,
  withdrawBondingCurve,
  withdrawFixedPrice,
} from '@/constants/contract';

import {
  getBcReserve,
  getMaticBcAaveValue,
  getMaticBcValue,
  getTokenBalance,
} from '@/constants/contract/read';

import { withWalletFlow, withThrottling } from '@/utils/with';
import { copyTx } from '@/utils';
import Popper from 'vue3-popper';
import BigNumber from 'bignumber.js';
import { mittContract } from '@/libs/event';

const $route = useRoute();

const passType = computed(() => $route.params.type);
const daoId = computed(() => $route.params.id);

const state = reactive({
  type: 'ALL',
  undrawProfit: '',
  info: {},
  history: {},
  daoId: '',
});

const jumpHash = (hash) => {
  return `${chainExplore[state.info.network]}/tx/${hash}`;
};

const baseInfo = computed(() => {
  const res = [
    { label: 'PASS Type', value: PassTypeLongText[state.info.passType] },
    { label: 'PASS Contract Type', value: state.info.passContractType },
    { label: 'Mainnet', value: state.info.network },
  ];

  if (passType.value === 'fixed_price') {
    /*  */
    res.push({ label: 'Payment', value: +state.info.payMent || '' });
    res.push({
      label: 'Term of validity',
      value: state.info.termOfValidity ? state.info.termOfValidity : '∞',
    });
    res.push({ label: 'Pay PASS With', value: state.info.payWith });
    res.push({
      label: 'Supply',
      value: state.info.totalSupply == '-1' ? '∞' : state.info.totalSupply,
    });
  }
  if (passType.value === 'bonding_curve') {
    res.push({ label: 'Pay PASS With', value: state.info.payWith });
    res.push({
      label: 'Creator Fee',
      value: state.info.creatorFee || '',
      type: 'percent',
    });
  }
  res.push({
    label: 'Platform Commission',
    value: state.info.platformCommission || '',
    type: 'percent',
  });

  return res;
});

const options = [
  { text: 'ALL', value: '' },
  { text: 'WITHDRAW', value: '' },
  { text: 'INCOME', value: '' },
];

const mapKey = {
  ALL: 'All',
  WITHDRAW: 'Withdraw',
  INCOME: 'Buy',
};

const decimalsMap = {
  MATIC: 18,
  ETH: 18,
  USDT: 6,
  DAI: 18,
  USDC: 6,
};

const loadData = async () => {
  const info = await getProfitsInfo(passType.value, state.daoId);
  const history = await getProfitsHistory(
    passType.value,
    state.daoId,
    mapKey[state.type],
  );
  try {
    let balance;
    if (passType.value === 'fixed_price') {
      balance = await getTokenBalance(
        getFixedTokenAddress(info.payWith, info.network),
        info.contractAddress,
        info.network,
      );
    } else {
      if (info.network == 'Ethereum') {
        const x = await getTokenBalance(
          BONDING_CURVE_OPTIONS_BY_NETWORK(info.network)[info.payWith].address,
          info.contractAddress,
          info.network,
        );
        const reserve = clearDecimals(
          await getBcReserve(info.contractAddress, info.network),
          BONDING_CURVE_OPTIONS_BY_NETWORK(info.network)[info.payWith].decimals,
        );
        balance = new BigNumber(x).minus(new BigNumber(reserve)).toString();
      } else {
        const a = (await getMaticBcValue(info.contractAddress)).toString();
        const b = (await getMaticBcAaveValue(info.contractAddress)).toString();
        balance = clearDecimals(
          new BigNumber(a).plus(new BigNumber(b)),
          BONDING_CURVE_OPTIONS_BY_NETWORK(info.network)[info.payWith].decimals,
        );
      }
    }

    state.undrawProfit = balance;
  } catch (error) {
    /*  */
  }

  const decimals = decimalsMap[info.payWith];
  history.forEach((x) => {
    x.quantity = cutZero(
      new BigNumber(x.quantity)
        .dividedBy(
          new BigNumber(
            1 +
              Array(decimals - 1)
                .fill(0)
                .join(''),
          ),
        )
        .toFixed(decimals),
    );
  });

  state.info = info;
  state.info.accumProfit = +new BigNumber(state.info.accumProfit)
    .dividedBy(
      new BigNumber(
        1 +
          Array(decimals - 1)
            .fill(0)
            .join(''),
      ),
    )
    .toFixed(decimals);
  state.history = history;
};

// TODO 提取操作...
const doWithdraw = withThrottling(
  withWalletFlow(
    async () => {
      // if (!(await checkChain(chains[state.info.network].chainId))) {
      //   return;
      // }

      try {
        mittContract(true, false);
        if (passType.value === 'fixed_price') {
          await withdrawFixedPrice(state.info.contractAddress, async () => {
            await loadData();
            await delayTime();
            mittContract(false);
          });
        } else {
          await withdrawBondingCurve(state.info.contractAddress, async () => {
            await loadData();
            await delayTime();
            mittContract(false);
          });
        }
      } catch (error) {
        handleWalletError(error);
        mittContract(false);
      }
    },
    () => state.info.network,
  ),
);

onMounted(async () => {
  state.daoId = await getDaoIdByName($route.params.name);
  loadData();
});

watch(
  () => $route.params.name,
  async (val) => {
    state.daoId = await getDaoIdByName($route.params.name);
    loadData();
  },
);

watch(
  () => state.type,
  async (val) => {
    state.history = await getProfitsHistory(
      passType.value,
      state.daoId,
      mapKey[val],
    );
  },
);
</script>

<style scoped>
.profit-bg {
  background-image: url('~@/assets/images/profit_bg.avif');
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.left-area {
  flex: 3;
}
.right-area {
  flex: 2;
}

.flex-item__label {
  cursor: pointer;
  display: none;
  background: linear-gradient(90deg, #8c1b29 0%, rgba(140, 27, 41, 0.2) 100%);
}

.flex-item__hover:hover .flex-item__value {
  opacity: 0.3;
}
.flex-item__hover:hover .flex-item__label {
  display: block;
}

.flex-item_3 {
  width: calc(33.3% - 0.25rem);
  height: 3rem;
  margin-top: 0.3rem;
  border: 0.15rem solid;
  border-image: linear-gradient(
      135deg,
      rgba(131, 24, 40, 1),
      rgba(131, 24, 40, 0.2)
    )
    2 2;
}
.flex-item_3:not(:nth-child(3n)) {
  margin-right: 0.3rem;
}

.flex-item_4 {
  width: calc(25% - 0.25rem);
  height: 3rem;
  margin-top: 0.3rem;
  border: 2px solid;
  border-image: linear-gradient(
      135deg,
      rgba(131, 24, 40, 1),
      rgba(131, 24, 40, 0.2)
    )
    2 2;
}
.flex-item_4:not(:nth-child(4n)) {
  margin-right: 0.3rem;
}

.border-line {
  border: 2px solid;
  border-image: linear-gradient(
      90deg,
      rgba(131, 24, 40, 1),
      rgba(131, 24, 40, 0.2)
    )
    2 2;
}
.line {
  height: 2px;
  background: linear-gradient(315deg, rgba(131, 24, 40, 0.2) 0%, #831828 100%);
}
.with-table {
}
.with-table__body,
.with-table__head {
  grid-template-columns: 2fr 5fr 5fr 3fr 5fr;
  height: 3rem;
}
.with-table__head > div:not(:last-child),
.with-table__body > div:not(:last-child) {
  /* border-right: 2px solid rgba(255, 255, 255, 0.1); */
}
.with-table__head > div {
  border-bottom: 2px solid rgba(255, 255, 255, 0.1);
}
:deep(.popper) {
  box-shadow: 8px 45px 32px 0px rgba(0, 0, 0, 0.4);
  border: 0.1rem solid;
  border-radius: 1rem;
  border-image: linear-gradient(
      90deg,
      rgba(149, 230, 246, 1),
      rgba(149, 230, 246, 0.2)
    )
    2 2;
}
</style>
